import { render, staticRenderFns } from "./LibroPage.vue?vue&type=template&id=6c8b37f0"
import script from "./LibroPage.js?vue&type=script&lang=js&external"
export * from "./LibroPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports